// lib/files.ts — read a File into base64 / text for uploads and audio (spec §6.1, §6.4).

export function readFileAsBase64(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result ?? '');
      resolve(result.includes(',') ? result.slice(result.indexOf(',') + 1) : result);
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
}

export function readFileAsText(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ''));
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsText(file);
  });
}

const TEXT_MIME = /^text\/|markdown|json|xml|yaml/;

export function isTextMime(mime: string): boolean {
  return TEXT_MIME.test(mime);
}

/** True for HTML uploads (by mime type or .html/.htm extension). */
export function isHtmlFile(mime: string, name: string): boolean {
  return /html/i.test(mime) || /\.html?$/i.test(name);
}

/** Extract readable text from HTML using the browser DOM parser (drops script/style). */
export function htmlToText(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('script, style, noscript').forEach((el) => el.remove());
  return (doc.body?.textContent ?? '').replace(/\s+/g, ' ').trim();
}

/** UTF-8-safe base64 encode (for pasted/typed document text). */
export function utf8ToBase64(s: string): string {
  const bytes = new TextEncoder().encode(s);
  let bin = '';
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin);
}
